import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/types';
import { useControlledSwr } from '@systemeio/util';
import { COUPONS_API } from 'modules/coupons/api/coupon-api';
import { CouponInterface } from 'modules/coupons/types/coupon-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export function useCustomerCoupons(currency, shouldFetch) {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== currency || $[2] !== shouldFetch) {
    t1 = () => {
      if (shouldFetch) {
        return [`${COUPONS_API}/list-by-currency/${currency}`, RequestModuleEnum.Coupons];
      }
      return null;
    };
    $[1] = currency;
    $[2] = shouldFetch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: coupons,
    mutate: mutateCoupons
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[4] !== coupons || $[5] !== mutateCoupons) {
    t2 = {
      coupons,
      mutateCoupons
    };
    $[4] = coupons;
    $[5] = mutateCoupons;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}